module.exports = __webpack_public_path__ + "static/media/gallus_gallus.13d52769.svg";